import { Close } from '@mui/icons-material';
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Skeleton,
  Typography,
} from '@mui/material';
import React from 'react';
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { ILegalClientLog } from '../../Interfaces/ILegalClientLog';
import { IMetadataLogin } from '../../Interfaces/IMetadataLogin';
import { useGetLegalClientDistributions } from '../../hooks/reactQuerys/DashboardQueries';

interface IProps {
  keyName: string;
  metadataLoginArray: IMetadataLogin[];
  activeDashboard: string[];
  setActiveDashboard: Function;
}

export const ComposedChartLogin: React.FC<IProps> = ({
  keyName,
  metadataLoginArray,
  activeDashboard,
  setActiveDashboard,
}) => {
  const { legalClientDistributions, isLoadingLegalClientDistributions } =
    useGetLegalClientDistributions();

  const chartData = () => {
    const resturnArray: any[] = [];
    if (legalClientDistributions) {
      for (let monat = 0; monat < 12; monat++) {
        console.log(legalClientDistributions[monat]);
        const monatStr = String(monat + 1).padStart(2, '0');

        const currentObject: any = {
          Monat: monatStr,
        };
        const monthData = legalClientDistributions[monat];
        if (monthData) {
          Object.entries(monthData).forEach(([key, value]) => {
            currentObject[key] = value;
          });
        }

        resturnArray.push(currentObject);
      }
    }

    return resturnArray;
  };

  const onRemove = () => {
    setActiveDashboard([...activeDashboard.filter(x => x !== keyName)]);
  };

  if (isLoadingLegalClientDistributions) {
    return <Skeleton width={300} height={500} sx={{ mt: -14 }} />;
  }

  if (!legalClientDistributions) {
    return <></>;
  }

  return (
    <>
      <Card variant='outlined'>
        <IconButton sx={{ float: 'right' }} onClick={onRemove}>
          <Close sx={{ fontSize: 14 }} />
        </IconButton>
        <CardContent>
          <Typography>Mandantenkonten (Monate)</Typography>
          <Box
            sx={{
              mt: 5,
              height: { xs: 150, sm: 250, xl: 300 },
              width: { xs: 300, sm: 375, xl: 450 },
            }}
          >
            <ResponsiveContainer width='100%' height='100%'>
              <ComposedChart data={chartData()}>
                <XAxis dataKey='Monat' />
                <YAxis
                  interval='preserveStartEnd' // Damit wir den Y-Achsenbereich automatisch anpassen können
                  //tickCount={10}  // Anzahl der Ticks auf der Y-Achse (du kannst dies anpassen)
                  tickFormatter={(value: number): string =>
                    Math.floor(value).toString()
                  } // Ganzzahliger Formatter
                />
                <Tooltip />
                <Legend />
                <CartesianGrid stroke='#f5f5f5' />
                {/*
                  MÖGLICHKEITEN
                  {
                    "Angemeldet": 0,
                    "Dokumente": 0,
                    "Einladung": 0,
                    "Einladung abgelehnt": 0,
                    "Einladung angenommen": 0,
                    "Erstellt / Gel\u00f6scht": 8817,
                    "Kommentare": 0,
                    "Konto entsperrt": 0,
                    "Konto gesperrt": 0,
                    "Password zur\u00fccksetzen": 0,
                    "Password zur\u00fccksetzen angefragt": 0,
                    "Sonstiges": 1,
                    "Vorgang": 1197
                  },
                 */}
                <Bar
                  dataKey='Angemeldet'
                  name='Anmeldungen'
                  barSize={20}
                  fill='#413ea0'
                />

                <Bar
                  dataKey='Erstellt / Gelöscht'
                  name='Erstellt'
                  barSize={20}
                  fill='#33ff57' // Dynamische Browserfarbe
                />
                <Bar
                  dataKey='Vorgang'
                  name='Vorgänge zugeordnet'
                  barSize={20}
                  fill='#ff6347'
                />
                <Line
                  type='monotone'
                  dataKey='Password zurückgesetzt'
                  name='Passwort zurückgesetzt'
                  stroke='#f0e130'
                />
                <Line
                  type='monotone'
                  dataKey='Einladungen'
                  name='Einladungen versendet'
                  stroke='#20b2aa'
                />
                <Line
                  type='monotone'
                  dataKey='Einladungen angenommen'
                  stroke='#adff2f'
                />
                <Line
                  type='monotone'
                  dataKey='Einladungen abgelehnt'
                  stroke='#ff8c00'
                />
              </ComposedChart>
            </ResponsiveContainer>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};
